import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query positionRatesById($id: Int!) {
    cat {
      position {
        byId(_id: $id) {
          _id
          pricing {
            received
            requested
          }
          bill_rate {
            min
            max
          }
          salary {
            min
            max
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type PositionRatesById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['position']>['byId']>

const usePositionRatesById = (id: number): PositionRatesById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'number'
  })
  const position = data?.cat?.position?.byId ?? undefined
  return position
}

export { usePositionRatesById, document as positionRatesByIdDocument }
